import React from 'react'
import PropTypes from 'prop-types'
import linkTypes from './enums/linkTypes'
import styles from './Home.icss'
import connectPropTypes from './utilities/connectPropTypes'
import Post from './utilities/Data/Post'
import Collection from './components/Collection'
import ExpandableKitItems from './components/ExpandableKitItems'
import FeedPostComment from './components/FeedPostComment'
import PostDetailsDisplay from './components/Item/PostDetailsDisplay'
import displayModes from './enums/displayModes'
import Thing from './utilities/Data/Thing'
import Item from './utilities/Data/Item'
import urlForPostComment from './utilities/urlForPostComment'
import urlForPostShare from './utilities/urlForPostShare'
import entityTypes from './enums/entityTypes'

//	Grab the right colour itemImages
const getItemImages = (myItem) => {
	const item = { ...myItem }
	const images = Item.getImages(item.item, item)
	return images
}


class Home extends React.Component {
	componentDidMount() {
		this.props.appBackButtonFunction(false)
		this.props.appBottomBarValue(linkTypes.HOME)
		this.props.feedFetch()
	}

	render() {
		const { feed, itemOwnByKey, kitOwnById, kudosPostSet, postKudosById, itemWantByKey, kitWantById } = this.props

		const renderAfterItem = (renderProps) => {
			const { item } = renderProps
			const kitItems = item.kit && item.kit.items
			return (
				<>
					<FeedPostComment myPost={item} showAddButton={false} />
					{kitItems && (
						<ExpandableKitItems
							classes={{ itemRoot: styles.itemRoot }}
							items={kitItems}
							itemTitle={kitItem => Thing.title(kitItem.item)}
							itemSubtitle={kitItem => Thing.subtitle(kitItem.item)}
							itemImageContent={kitItem => getItemImages(kitItem)}
							itemHref={kitItem => Thing.href(kitItem.item)}
							itemOnSelect={kitItem => this.props.appRedirect(Thing.href({ ...kitItem.item, colour: { colourName: kitItem.colourName } }))}
							itemShowOwnWant
							itemOwn={kitItem => Thing.isOwned({ itemOwnByKey })(kitItem.item, kitItem.colourName)}
							itemWant={kitItem => Thing.isWanted({ itemWantByKey })(kitItem.item, kitItem.colourName)}
							itemOwnSet={Thing.propertyGetter({
								[entityTypes.ITEM.type]: kitItem => own => this.props.itemOwnSet({ own, item: kitItem })
							})}
							itemWantSet={Thing.propertyGetter({
								[entityTypes.ITEM.type]: kitItem => want => this.props.itemWantSet({ want, item: kitItem })
							})}
							renderAfterCollection={<PostDetailsDisplay post={item} />}
						/>
					) }
				</>
			)
		}

		return (!feed ? null : (
			<div className={styles.wrapper}>
				<div className={styles.resultWrapper}>
					<Collection
						allowedDisplayModes={[displayModes.FULL.type]}
						items={feed}
						{...Post.feedCollectionProps}
						itemOwn={Post.isOwned({ itemOwnByKey, kitOwnById })}
						itemWant={Post.isWanted({ itemWantByKey, kitWantById })}
						itemFollowSet={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.USER.type]: user => isFollowing => this.props.postFollowersSet({ uid: user.uid, isFollowing })
						}))}
						itemOwnSet={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.ITEM.type]: item => own => this.props.itemOwnSet({ own, item }),
							[entityTypes.KIT.type]: kit => own => this.props.kitOwnSet({ own, kit })
						}))}
						itemWantSet={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.ITEM.type]: item => want => this.props.itemWantSet({ want, item }),
							[entityTypes.KIT.type]: kit => want => this.props.kitWantSet({ want, kit })
						}))}
						itemShowCountComments
						itemCountComments={post => post.countComments}
						itemCountCommentsClick={post => () => this.props.appRedirect(urlForPostComment({ postId: post.postId }))}
						itemShareClick={post => () => this.props.appRedirect(urlForPostShare({ postId: post.postId }))}
						itemKudos={Post.isKudos({ postKudosById })}
						itemKudosSet={post => kudos => kudosPostSet({ kudos, post })}
						itemKudosCount={Thing.kudosCount}
						renderAfterItem={renderAfterItem}
					/>
				</div>
			</div>
		))
	}
}

Home.contextTypes = {
	translate: PropTypes.func
}

Home.propTypes = {
	feed: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	appRedirect: PropTypes.func.isRequired,
	feedFetch: PropTypes.func.isRequired,
	appBottomBarValue: PropTypes.func.isRequired,
	appBackButtonFunction: PropTypes.func.isRequired,
	postFollowersSet: PropTypes.func.isRequired,
	itemOwnSet: PropTypes.func.isRequired,
	kitOwnSet: PropTypes.func.isRequired,
	itemWantSet: PropTypes.func.isRequired,
	kitWantSet: PropTypes.func.isRequired,
	kudosPostSet: PropTypes.func.isRequired,
	postKudosById: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	itemOwnByKey: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	kitOwnById: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	itemWantByKey: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	kitWantById: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

Home.defaultProps = {
	feed: undefined,
	postKudosById: undefined,
	itemOwnByKey: undefined,
	kitOwnById: undefined,
	itemWantByKey: undefined,
	kitWantById: undefined
}

export const testing = {
	Home
}

export default connectPropTypes(Home)



// WEBPACK FOOTER //
// ./src/Home.jsx